// Mantener la limpieza de borradores independiente del formulario pesado.
// Se usa al cerrar sesión o abandonar el módulo de Poderes.
export const POWER_DRAFT_STORAGE_PREFIX = 'wisby:poder-draft:';

export function clearStoredPowerDrafts() {
  if (typeof window === 'undefined') return;
  Object.keys(window.localStorage)
    .filter(key => key.startsWith(POWER_DRAFT_STORAGE_PREFIX))
    .forEach(key => window.localStorage.removeItem(key));
}
